<div class="justup-dialog achat-articles-dialog flex-container">
  <vl-dialog-header-export
    [exporting]="exporting()"
    (close)="dialogRef.close()"
    (export)="exportExcel()">
    Articles achetés — {{ data.tiersDenomination }}
  </vl-dialog-header-export>

  <div class="justup-dialog-content flex-col gap-16">
    <!-- Stats cards chunky (pattern Répartition CA) -->
    <div class="flex-row gap-8 wrap">
      <vl-radio-card mode="display" color="warn" icon="payments" [title]="'Coût total'" style="flex: 1; min-width: 140px">
        <span content class="headline">{{ stats().coutTotalFormatted }}</span>
      </vl-radio-card>

      <vl-radio-card mode="display" color="valid" icon="inventory_2" [title]="'Articles achetés'" style="flex: 1; min-width: 140px">
        <div content class="flex-col gap-2">
          <span class="headline">{{ stats().nbArticles }}</span>
          <span class="tiny" style="opacity: 0.7">{{ stats().nbCommandes }} commande{{ stats().nbCommandes > 1 ? 's' : '' }}</span>
        </div>
      </vl-radio-card>

      <vl-radio-card mode="display" color="warn" icon="leaderboard" [title]="'Concentration 80%'" style="flex: 1; min-width: 140px">
        <div content class="flex-col gap-2">
          <div class="flex-row align-baseline gap-4">
            <span class="headline">{{ stats().pareto80Count }}</span>
            <span class="body-2" style="opacity: 0.7">/ {{ stats().nbArticles }}</span>
          </div>
          <span class="tiny" style="opacity: 0.7">représentent 80% du coût</span>
        </div>
      </vl-radio-card>
    </div>

    <!-- Column headers -->
    <div class="column-headers">
      <span class="spacer-pill"></span>
      <span class="label">Articles</span>
      <span class="metric" matTooltip="Quantité achetée en unité de gestion et unité d'achat">Quantités</span>
      <span class="metric" matTooltip="Prix unitaire d'achat moyen">PU moy.</span>
      <span class="metric" matTooltip="Coût total d'achat">Coût</span>
      <span class="part" matTooltip="Part du coût total">Part</span>
    </div>

    <!-- Articles list -->
    <div class="flex-col gap-2">
      @for (art of sortedArticles(); track art.articleId) {
        <div>
          <div class="article-row"
               [style.border-left]="'3px solid ' + colorFor(art.articleId)"
               (click)="toggle(art.articleId)">
            <mat-icon class="on-disabled shrink-0" style="font-size: 16px; width: 16px; height: 16px">
              {{ isOpen(art.articleId) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
            <span class="color-pill" [style.background-color]="colorFor(art.articleId)"></span>
            <span class="label on-background-alt">{{ art.articleDenomination }}</span>
            <div class="metric flex-col gap-0">
              <span class="on-background-alt" style="font-weight: 600">{{ art.qtyUG | number:'1.0-2' }} {{ art.uniteGestion }}</span>
              @if (art.uniteAchat !== art.uniteGestion) {
                <span class="tiny on-disabled">{{ art.qtyUA | number:'1.0-2' }} {{ art.uniteAchat }}</span>
              }
            </div>
            <div class="metric flex-col gap-0">
              <span class="on-background-alt" style="font-weight: 600">{{ art.puUGMoyen | number:'1.2-2' }} €/{{ art.uniteGestion }}</span>
              @if (art.uniteAchat !== art.uniteGestion) {
                <span class="tiny on-disabled">{{ art.puUAMoyen | number:'1.2-2' }} €/{{ art.uniteAchat }}</span>
              }
            </div>
            <span class="metric on-disabled">{{ art.coutTotal | number:'1.0-0' }} €</span>
            <span class="part on-accent">{{ percentPart(art.coutTotal) }}%</span>
          </div>

          @if (isOpen(art.articleId)) {
            <div class="children-wrap">
              @for (cmd of art.commandes; track cmd.commandeId) {
                <div>
                  <div class="commande-row" (click)="toggle(art.articleId + '::' + cmd.commandeId); $event.stopPropagation()">
                    <mat-icon class="chevron on-disabled" style="font-size: 14px; width: 14px; height: 14px">
                      {{ isOpen(art.articleId + '::' + cmd.commandeId) ? 'expand_more' : 'chevron_right' }}
                    </mat-icon>
                    <div class="label-sub flex-col">
                      <span class="on-background-alt">{{ cmd.numero }}</span>
                      <span class="tiny on-disabled">{{ formatDate(cmd.dateKey) }}</span>
                    </div>
                    <div class="metric flex-col gap-0">
                      <span class="on-background-alt" style="font-weight: 600">{{ cmd.qtyUG | number:'1.0-2' }} {{ art.uniteGestion }}</span>
                      @if (art.uniteAchat !== art.uniteGestion) {
                        <span class="tiny on-disabled">{{ cmd.qtyUA | number:'1.0-2' }} {{ art.uniteAchat }}</span>
                      }
                    </div>
                    <div class="metric flex-col gap-0">
                      <span class="on-background-alt" style="font-weight: 600">{{ cmd.puUGMoyen | number:'1.2-2' }} €/{{ art.uniteGestion }}</span>
                      @if (art.uniteAchat !== art.uniteGestion) {
                        <span class="tiny on-disabled">{{ cmd.puUAMoyen | number:'1.2-2' }} €/{{ art.uniteAchat }}</span>
                      }
                    </div>
                    <span class="metric on-disabled">{{ cmd.coutTotal | number:'1.0-0' }} €</span>
                    <span class="part on-accent">{{ percentPart(cmd.coutTotal) }}%</span>
                  </div>

                  @if (isOpen(art.articleId + '::' + cmd.commandeId) && cmd.lots.length) {
                    @for (lot of cmd.lots; track lot.lotNumero) {
                      <div class="lot-row">
                        <div class="label-sub">
                          @if (lot.lotId) {
                            <vl-lot-card [lotId]="lot.lotId" mode="text"/>
                          } @else {
                            <span class="on-background-alt" style="font-weight: 600">{{ lot.lotNumero || '— lot inconnu —' }}</span>
                          }
                        </div>
                        <span class="metric on-background-alt">
                          {{ lot.qtyUG | number:'1.0-2' }} {{ art.uniteGestion }} × {{ lot.puUG | number:'1.2-2' }} €
                          @if (art.uniteAchat !== art.uniteGestion) {
                            <span class="tiny on-disabled"> ({{ lot.qtyUA | number:'1.0-2' }} {{ art.uniteAchat }})</span>
                          }
                        </span>
                        <span class="metric on-disabled" style="font-weight: 600">{{ lot.coutTotal | number:'1.0-0' }} €</span>
                      </div>
                    }
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
